<template>
	<div class="member" @click="showMemberDialog">
		<div class="image">
			<!-- Se l'utente ha caricato una foto, la mostro -->
			<UserPicture
				v-if="user.picture_url && !user.picture_url.includes('gravatar')"
				class="s-3"
				:src="user.picture_url"
			/>

			<!-- Altrimenti mostro le iniziali -->
			<UserPicture
				v-else
				class="s-3"
				:src="'https://ui-avatars.com/api/?name=' + user.first_name + '+' + user.last_name + '&size=64&length=4&font-size=0.3'"
			/>
		</div>

		<div class="info">
			<div class="name">{{ user.first_name }} {{ user.last_name }}</div>
			<div class="email">{{ user.email }}</div>
		</div>

		<!-- <div class="actions">
			<Options :options="{}">
				<div class="icon-md f-m">more_verts</div>
			</Options>
		</div> -->
	</div>
</template>

<script>
export default {
	name: 'member',

	props: {
		// User data
		user: {
			type: Object,
			required: true
		}
	},

	methods: {
		/**
		 *
		 */
		showMemberDialog() {
			this.$pop.push({
				props: {
					comp: () => import('./UserDialog'),
					user: this.user
				},
				on: {
					delete: () => {
						this.$pop.pop();
						this.$emit('delete', this.user.id);
					},
					membership: () => this.$emit('membership', this.user.id),

					// 👇 nuovo listener: chiude il dialog
					close: () => this.$pop.pop()
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
.member
	display flex
	align-items center

	transition 0.15s ease

	cursor pointer

	&:hover
		border-radius 0.5em

		background-color darker

	.image
	.info
	.actions
		padding 1em
	
	.info
		flex-grow 1

		.name
			font-size 1.4em
			font-weight bold
		
		.email
			font-style italic
</style>